var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#587E85",
    fillRule: "evenodd",
    d: "M14.317 4.826H2.313l3.611-3.63c.187-.17.266-.43.205-.675-.06-.246-.25-.438-.495-.5-.244-.062-.503.016-.672.204L.183 5.028c-.033.03-.061.065-.085.103-.011.017-.022.036-.03.055 0 .02-.024.041-.035.065l-.02.069c-.002.019-.002.039 0 .058-.017.09-.017.181 0 .271v.058l.02.069c0 .024.024.045.034.065l.031.052c.024.037.051.071.082.103l4.778 4.803c.267.268.7.268.966 0 .267-.268.267-.703 0-.971l-3.61-3.63h12.003c.377 0 .683-.307.683-.686 0-.38-.306-.686-.683-.686z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackIcon);
export default __webpack_public_path__ + "static/media/arrow-back-icon.a630a05132ad60bf087dff0ef3bcc23f.svg";
export { ForwardRef as ReactComponent };